var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscribe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 281,
    viewBox: "0 0 262 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.88 115.867L198.405 98.0022L224.654 101.686L235.649 273.825L243.169 280.853H205.15L191.268 209.658L194.88 115.867Z",
    fill: "#73314F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.207 205.734C217.207 230.185 211.304 251.904 202.167 265.623L191.256 209.666L194.072 136.551C207.67 147.979 217.207 174.652 217.207 205.734Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.084 273.608L215.579 100.823",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.579 100.823L166.804 98.0022V150.752V280.853H205.137L201.084 273.608L215.579 100.823Z",
    fill: "#73314F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.846 14.3585V29.415L211.542 33.9995V8.59082L192.846 4.00635V14.3585Z",
    fill: "#EDEEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.411 19.5655C203.135 19.5655 202.911 19.3423 202.911 19.0668C202.911 18.7914 203.135 18.5681 203.411 18.5681C203.687 18.5681 203.911 18.7914 203.911 19.0668C203.911 19.3423 203.687 19.5655 203.411 19.5655Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.729 19.5655C195.453 19.5655 195.229 19.3423 195.229 19.0668C195.229 18.7914 195.453 18.5681 195.729 18.5681C196.005 18.5681 196.229 18.7914 196.229 19.0668C196.229 19.3423 196.005 19.5655 195.729 19.5655Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.979 22.051V14.3652H194.12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.352 14.3528H200.493",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.311 18.2914V20.9603C211.754 20.9603 212.924 19.7932 212.924 18.3535C212.924 18.2735 212.921 18.1945 212.913 18.1163C212.767 16.4975 210.311 16.6661 210.311 18.2914Z",
    fill: "#EDEEEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.311 20.9649C211.754 20.9649 212.924 19.7978 212.924 18.3582",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.668 23.9409C201.128 23.9409 202.312 22.7596 202.312 21.3025",
    stroke: "#73314F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.845 29.4114L211.542 33.9957",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.976 22.0474L199.665 22.4613",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.306 16.9866C210.306 16.9866 206.366 13.3334 206.807 9.28969L192.84 8.49854",
    stroke: "#73314F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.837 12.7424C192.837 12.7424 188.858 8.6514 193.513 4.00379C198.168 -0.643827 214.558 3.31195 214.558 3.31195C214.558 3.31195 220.142 17.0459 211.534 23.9362",
    stroke: "#73314F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.65 60.956V101.686L166.812 115.867V70.5054C166.812 54.4209 177.819 40.4145 193.477 36.5754H193.477C200.985 34.7344 208.926 36.4388 215.011 41.1979C221.096 45.957 224.65 53.2424 224.65 60.956V60.956Z",
    fill: "#EDEEEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M201.084 273.608L215.579 100.823",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.95 45.9189C176.95 45.9189 165.597 57.1701 161.329 78.6282C161.329 78.6282 161.477 57.1709 153.37 46.2072C145.263 35.2434 144.117 40.708 146.585 45.9189C146.585 45.9189 142.531 49.196 146.585 54.8219C146.585 54.8219 129.196 132.707 179.012 99.1852",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M218.999 45.1089C218.999 45.1089 228.828 56.2979 233.763 82.5525C233.763 82.5525 246.217 63.7992 253.266 60.5174C260.316 57.2356 262.196 60.283 260.316 61.6895C259.02 62.6079 257.594 63.3295 256.086 63.8307C256.086 63.8307 260.081 69.5714 255.381 73.7178C255.381 73.7178 249.37 119.939 224.648 107.575",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7519 115.522L35.6045 90.2129L47.9255 280.301H10.7519L16.2428 272.828C15.8908 243.68 10.7519 115.522 10.7519 115.522Z",
    fill: "#E2E2E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6476 100.488L60.8665 97.6709L68.3616 100.716L71.884 280.292H33.599L37.647 273.056L19.6476 100.488Z",
    fill: "#EDEEEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5985 280.304L37.6465 273.067L19.6472 100.499",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6348 14.1317V20.6222C52.6348 25.641 49.2002 30.0113 44.3148 31.2092L33.9612 33.7478V8.37104L42.5701 6.26022C44.9944 5.66582 47.558 6.21611 49.5226 7.75262C51.4872 9.28913 52.6348 11.6413 52.6348 14.1317V14.1317Z",
    fill: "#EDEEEF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6348 20.6309C52.6348 25.6496 49.2002 30.0199 44.3148 31.2178L33.9612 33.7564",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0805 19.3267C41.8048 19.3267 41.5812 19.1037 41.5812 18.8287C41.5812 18.5536 41.8048 18.3306 42.0805 18.3306C42.3563 18.3306 42.5798 18.5536 42.5798 18.8287C42.5798 19.1037 42.3563 19.3267 42.0805 19.3267Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7412 19.3267C49.4654 19.3267 49.2419 19.1037 49.2419 18.8287C49.2419 18.5536 49.4654 18.3306 49.7412 18.3306C50.0169 18.3306 50.2405 18.5536 50.2405 18.8287C50.2405 19.1037 50.0169 19.3267 49.7412 19.3267Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5068 21.8108V14.135H51.3616",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1411 14.137H44.9958",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1797 18.0668V20.7324C33.7383 20.7324 32.5699 19.5668 32.5699 18.1289C32.5699 18.049 32.5734 17.97 32.5806 17.8919C32.7268 16.2752 35.1797 16.4436 35.1797 18.0668Z",
    fill: "#EDEEEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1797 20.7244C33.7383 20.7244 32.5699 19.5587 32.5699 18.1208",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3865 22.707C45.0624 23.0303 44.6228 23.212 44.1645 23.212C43.7062 23.212 43.2666 23.0303 42.9425 22.707",
    stroke: "#4F7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4915 21.8174L45.8055 22.2308",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5203 60.6798V101.358L10.7547 115.522V70.2172C10.7547 54.1529 21.7481 40.1641 37.3858 36.3299H37.3858C44.8851 34.4911 52.8155 36.1935 58.8929 40.9466C64.9704 45.6997 68.5203 52.9759 68.5203 60.6798V60.6798Z",
    fill: "#4F7D7D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8796 28.1784C33.8796 28.1784 36.2638 34.5582 30.4406 38.3626C24.9505 41.9495 20.4234 29.513 23.2437 20.6747C23.4082 20.1619 23.4896 19.6261 23.4847 19.0876C23.4496 15.6228 24.4238 2.17166 41.5803 1.2544C53.0409 0.641662 62.4639 8.99006 53.0235 18.3501",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6348 14.1307C52.6348 14.1307 48.9876 14.762 47.2274 9.84546C47.2274 9.84546 41.6951 17.5129 35.1912 16.3423L34.7277 17.0575",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6398 38.5564C23.6398 38.5564 23.4528 41.8223 30.0002 40.6092",
    stroke: "#4F7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3814 41.7537C22.3814 41.7537 18.708 56.3277 25.7486 54.3962C32.7892 52.4647 28.2128 43.6852 28.2128 43.6852",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1098 24.4207L81.5838 21.816L124.531 1.18652L106.402 33.7502L102.178 29.1715L99.0325 34.7244L97.0432 27.698",
    fill: "#4F7D7D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0004 36.8315C51.0004 36.8315 68.336 42.1004 79.4242 70.5957C79.4242 70.5957 89.2658 29.7461 91.6164 27.3508C95.2541 23.6438 100.359 21.0295 98.7157 24.7754C97.0729 28.5214 95.4301 29.1729 95.4301 29.1729C95.4301 29.1729 99.8892 32.8314 96.8382 35.5929",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M101.553 21.8126C102.004 21.382 108.223 35.1951 100.361 43.0382C100.361 43.0382 114.442 151.905 45.8152 86.3507",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6053 89.8728C49.6053 89.8728 54.6778 122.873 68.5203 132.883V103.666C68.5203 103.666 50.8348 91.0047 49.6053 89.8728Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 51.2371C16.3789 51.2371 -14.1019 93.0222 10.7506 136.569",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/Subscribe.4dd40ac21368c13a29e54cf88cd5e179.svg";
export { ForwardRef as ReactComponent };